module.exports = __webpack_public_path__ + "media/images/bg-login-9dae8c2a0ca95822eb7aea0cca7a6be8.jpg";